import React, {FC, memo} from 'react';
import {AsyncPaginate} from 'react-select-async-paginate';
import cnBind from 'classnames/bind';
import { getLoadUserOptions } from '@/apps/Applications/helpers';
import styles from './styles/index.module.scss';
import {customStylesSelect} from '../../const';
import {ISelect} from '../../interfaces';


const cn = cnBind.bind(styles);

const SelectStaff: FC<ISelect> = ({value, onChangeSelect, classNameBlock, name, params}) => {
	const loadOptions = (search:string) => {
    return getLoadUserOptions({search,params})
  }

  return (
    <AsyncPaginate
      isClearable
      placeholder='Выберите'
      loadOptions={loadOptions}
      onChange={onChangeSelect}
      additional={{page: 1}}
      value={value}
      name={name}
      noOptionsMessage={() => 'Ничего не найдено'}
      loadingMessage={() => 'Поиск...'}
      className={cn(styles['item-select'], classNameBlock)}
      styles={customStylesSelect}
    />
  );
}

export default memo(SelectStaff);